import CookiesStore from "./Storage/cookiesStore";

class AgeRestrictedContext {
    static accepted = false;
    static alcohol = false;
    static initialize(disabled?:any){
        if(disabled){
            this.accepted = true;
        }else{
            this.accepted = CookiesStore.get("age_restricted_accepted");
        }
    }
    static setAlcohol(value:any){
        this.alcohol = value;
    }
    static isAlcohol() {
        return this.alcohol;
    }
    static isAccepted(){
        if(!this.accepted) this.initialize();
        return this.accepted;
    }
    static accept(){
        CookiesStore.set("age_restricted_accepted", true);
        this.accepted = true;
    }
    static isItemEnergyDrink(value:any){
        return !!(value.custom_fields && value.custom_fields.drink_type && value.custom_fields.drink_type == "energy_drink");
    }
    static isItemAlcohol(value:any){
        return !!(value.custom_fields && value.custom_fields.drink_type && value.custom_fields.drink_type == "alcohol");
    }
}
export default AgeRestrictedContext;
